/**
 * "Act as company" state for global admins.
 * Stored in localStorage so effective company persists across reloads and is
 * available to getCurrentUserCompanyId() and session resolution.
 */

const ACT_AS_STORAGE_KEY = "menubrain_act_as_company_id";

export function getActAsCompanyId(): string | null {
  if (typeof window === "undefined") return null;
  const id = localStorage.getItem(ACT_AS_STORAGE_KEY);
  return id || null;
}

export function setActAsCompanyId(companyId: string | null): void {
  if (typeof window === "undefined") return;
  if (companyId == null) {
    localStorage.removeItem(ACT_AS_STORAGE_KEY);
  } else {
    localStorage.setItem(ACT_AS_STORAGE_KEY, companyId);
  }
}
